import { useState } from "react";
import Counter from "../components/Count/HTimer";
import HackLogo from "../components/assets/HackLogo.png";
export default function Hero() {
  const startDate = new Date("2024-04-27T19:00:00");
  const endDate = new Date(startDate.getTime() + 24 * 60 * 60 * 1000);
  return (
    <div className="bg-[#5681EA] h-screen">
      <div className="relative isolate px-6 pt-14 lg:px-8">
        <div
          className="absolute inset-x-0 -top-40 -z-10 transform-gpu overflow-hidden blur-3xl sm:-top-80"
          aria-hidden="true"
        >
          <div className="relative left-[calc(50%-11rem)] aspect-[1155/678] " />
        </div>
        <div className="mx-auto max-w-2xl py-32 sm:py-48 lg:py-56">
          <div className="hidden sm:mb-8 sm:flex sm:justify-center"></div>
          <div className="text-center">
            <img className="max-w-full h-auto" src={HackLogo} alt="HackLogo" />
            <div className="mt-10 flex items-center justify-center flex-col gap-x-6">
              <p className="mt-6 text-lg leading-8 text-[#f4f4f4] font-main"></p>
              <Counter startDate={startDate} endDate={endDate} />
            </div>
          </div>
        </div>
        <div
          className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
          aria-hidden="true"
        ></div>
      </div>
    </div>
  );
}
